/* eslint-disable max-len */
import React from 'react'

export const SlackIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="23" viewBox="0 0 24 23" fill="none">
      <path
        d="M2.81231 12.3754C1.60429 12.3754 0.625001 13.3547 0.625001 14.5627V14.5627C0.625001 15.7707 1.60439 16.75 2.81241 16.75V16.75C4.02053 16.75 5 15.7706 5 14.5625V12.3754H2.81231ZM8.9375 12.3754C7.72938 12.3754 6.75 13.3548 6.75 14.5629V20.6875C6.75 21.8956 7.72938 22.875 8.9375 22.875V22.875C10.1456 22.875 11.125 21.8956 11.125 20.6875V14.5629C11.125 13.3548 10.1456 12.3754 8.9375 12.3754V12.3754Z"
        fill="#E01E5A"
      />
      <path
        d="M12.8751 20.6877C12.8751 21.8957 13.8544 22.875 15.0624 22.875V22.875C16.2705 22.875 17.2498 21.8956 17.2498 20.6876V20.6876C17.2498 19.4795 16.2704 18.5 15.0623 18.5L12.8751 18.5L12.8751 20.6877ZM12.8751 14.5625C12.8751 15.7706 13.8545 16.75 15.0626 16.75L21.1873 16.75C22.3954 16.75 23.3748 15.7706 23.3748 14.5625V14.5625C23.3748 13.3544 22.3954 12.375 21.1873 12.375L15.0626 12.375C13.8545 12.375 12.8751 13.3544 12.8751 14.5625V14.5625Z"
        fill="#ECB22E"
      />
      <path
        d="M21.1877 10.6246C22.3957 10.6246 23.375 9.64533 23.375 8.43731V8.43731C23.375 7.22929 22.3956 6.25 21.1876 6.25V6.25C19.9795 6.25 19 7.22938 19 8.4375V10.6246H21.1877ZM15.0625 10.6246C16.2706 10.6246 17.25 9.64525 17.25 8.43712V2.3125C17.25 1.10437 16.2706 0.125 15.0625 0.125V0.125C13.8544 0.125 12.875 1.10438 12.875 2.3125V8.43713C12.875 9.64525 13.8544 10.6246 15.0625 10.6246V10.6246Z"
        fill="#2EB67D"
      />
      <path
        d="M11.1249 2.31231C11.1249 1.10429 10.1456 0.125001 8.93756 0.125V0.125C7.72954 0.125 6.75025 1.10439 6.75025 2.31241V2.31241C6.75025 3.52053 7.72962 4.5 8.93775 4.5L11.1249 4.5L11.1249 2.31231ZM11.1249 8.4375C11.1249 7.22938 10.1455 6.25 8.93737 6.25L2.81274 6.25C1.60462 6.25 0.625244 7.22938 0.625244 8.4375V8.4375C0.625244 9.64562 1.60462 10.625 2.81274 10.625L8.93737 10.625C10.1455 10.625 11.1249 9.64562 11.1249 8.4375V8.4375Z"
        fill="#36C5F0"
      />
    </svg>
  )
}
